import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    posts: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    statusStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        posts: blockContent?.posts ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    statusClear: () => initialState,

    statusUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    statusUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    statusUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  statusStore,
  statusClear,
  statusUpdateIsLoading,
  statusUpdateIsActive,
  statusUpdateBlockContent,
} = statusSlice.actions;

export const selectStatusIsLoading = (state) => state.status.isLoading;
export const selectStatusId = (state) => state.status.id;
export const selectStatusUID = (state) => state.status.uid;
export const selectStatusSID = (state) => state.status.sid;
export const selectStatusBlockContent = (state) => state.status.blockContent;
export const selectStatusItemDesign = (state) => state.status.itemDesign;
export const selectStatusContainerDesign = (state) => state.status.containerDesign;

export default statusSlice.reducer;
